import { render, staticRenderFns } from "./work-demo.vue?vue&type=template&id=e513cc7c&"
import script from "./work-demo.vue?vue&type=script&lang=js&"
export * from "./work-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports